import { Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Drawer, Typography } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { LoadingStatus } from 'components/common/LoadingStatus/LoadingStatus';

const useStyles = makeStyles({
    PaperOverWrite: (base) => (
        {
            ...base,
            scrollbarGutter: 'stable'
        }
    ),
    root: {
        width: '600px',
        height: 'auto',
        marginBottom: '50px',
        padding: '20px',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        fontFamily: 'Hind'
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        paddingBottom: '20px',
        marginBottom: '10px',
        borderBottom: '1px solid #B1B1B1',
        '& > p': {
            color: '#2057AD',
            fontWeight: 600,
        },
        '& > svg': {
            color: '#151B94',
            cursor: 'pointer',
            fontSize: '20px',
            fontWeight: 900,
            '&:hover': {
                color: 'red'
            }
        },
    },
    footer: {
        margin: '20px 20px 0',
        padding: '10px 0',
        width: '600px',
        borderTop: '1px solid #B1B1B1',
        position: 'fixed',
        bottom: '0px',
        backgroundColor: 'inherit'
    }
});

export default function Index({children, renderFooter, open, anchor, headerTitle , handleOnClose, onCancel, isLoading = false}) {
    const classes = useStyles();
    const footer = renderFooter();

    return (
        <Fragment>
            <Drawer
                anchor={anchor}
                open={open}
                onClose={handleOnClose}
                classes={{
                    paper: classes.PaperOverWrite
                }}
            >
                <div className={classes.root}>
                    <div className={classes.header}>
                        <Typography>{headerTitle}</Typography>
                        <Close onClick={onCancel} />
                    </div>
                    {isLoading ? (
                        <LoadingStatus loading={isLoading} filterQuery={false} />
                    ) : (
                        children
                    )}
                </div>
                {
                    !isLoading && (
                        <div className={classes.footer}>
                            {footer}
                        </div>
                    )
                }
            </Drawer>
        </Fragment>
    );
}